import ImageUploader from "react-images-upload";
import React, { useState, memo } from "react";
import Select from "react-select";
import { Switch } from "@blueprintjs/core";
import Swal from "sweetalert2";

// COMPONENTS
import DropZone from "../Dropzone/Dropzone";

// AWS
import { S3Image } from "aws-amplify-react";
import { API, Auth, Storage } from "aws-amplify";

// UTILS
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";

function GiftCreateUpdate({
  close,
  item,
  setItem,
  closeModal,
  title = "เพิ่มสินค้า",
}) {
  const defaultItem = {
    name: "",
    price: 0,
    desc: "",
    term: "",
    is_recommend: { label: "ทั่วไป", value: false },
    category: null,
    picture: null,
    pictureSecond: null,
    pictureThird: null,
    img: new Array(3).fill(null),
  };

  let sourceItem = {};

  if (item) {
    sourceItem = {
      ...item,
      category: { label: item.category, value: item.category },
      is_recommend: {
        label: item.is_recommend === "true" ? "ยอดนิยม" : "ทั่วไป",
        value: item.is_recommend === "true" ? true : false,
      },
    };
  }

  const [form, setForm] = useState(Object.assign(defaultItem, sourceItem));

  const getFormatS3 = async (name) => {
    const fileName = `S${getCurrentLocalDateTime().timestamp}_${
      form[name].name
    }`;
    return await Storage.put(fileName, form[name]);
  };

  const onCreate = async () => {
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          let img = [];

          if (form.picture) {
            const pictureOneS3 = await getFormatS3("picture");
            img.push(pictureOneS3.key);
          }
          if (form.pictureSecond) {
            console.log("1");
            const pictureSecondS3 = await getFormatS3("pictureSecond");
            img.push(pictureSecondS3.key);
          }
          if (form.pictureThird) {
            console.log("2");
            const pictureThirdS3 = await getFormatS3("pictureThird");
            img.push(pictureThirdS3.key);
          }

          console.log("IMG", img);

          const { name, price, desc, term, category, is_recommend } = form;

          const timestamp = getCurrentLocalDateTime().timestamp;

          await API.post("MoneyHubAdmin", `/gift`, {
            body: {
              name,
              price: +price,
              desc,
              term,
              category: category.value,
              img,
              timestamp,
              is_recommend: is_recommend.value,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "สร้างสินค้าสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      closeModal();
    } catch (error) {
      console.log("Error", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onUpdate = async () => {
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          let img = form.img;

          img[0] = item?.img[0];
          if (form.picture) {
            const pictureOneS3 = await getFormatS3("picture");
            img[0] = pictureOneS3.key;
          }

          img[1] = item?.img[1];
          if (form.pictureSecond) {
            const pictureSecondS3 = await getFormatS3("pictureSecond");
            img[1] = pictureSecondS3.key;
          }

          img[2] = item?.img[2];
          if (form.pictureThird) {
            const pictureThirdS3 = await getFormatS3("pictureThird");
            img[2] = pictureThirdS3.key;
          }

          const { name, price, desc, term, category, is_recommend } = form;

          console.log("IMG", img);

          await API.put("MoneyHubAdmin", `/gift/${item.shop_id}`, {
            body: {
              name,
              price: +price,
              desc,
              term,
              category: category.value,
              img,
              is_recommend: is_recommend.value,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "สร้างสินค้าสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      closeModal();
    } catch (error) {
      console.log("Error", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  const onChangeTextField = (e) => {
    const name = e.target.name;
    setForm((prev) => {
      return {
        ...prev,
        [name]: e.target.value,
      };
    });
  };

  const onDrop = (pictureName) => (pictureFiles, pictureDataURLs) => {
    setForm((prev) => {
      return {
        ...prev,
        [pictureName]: pictureFiles[0],
      };
    });
  };

  const onChangeSelect = (name) => (e) => {
    setForm((prev) => {
      return {
        ...prev,
        [name]: e,
      };
    });
  };

  const onDeleteImg = (index) => () => {
    setForm((prev) => {
      const newItem = { ...prev };
      newItem.img[index] = null;
      return newItem;
    });
  };

  return (
    <div className="w-full px-8 ">
      <div className="flex flex-row justify-between mb-4">
        <div
          className="flex flex-row justify-between"
          onClick={() => closeModal()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            onClick={close}
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          <div className="font-bold text-lg text-black ml-16">{title}</div>
        </div>
        <button
          onClick={item ? onUpdate : onCreate}
          className="bg-green-500 text-white rounded p-2 w-24 -mt-2 "
        >
          ยืนยัน
        </button>
      </div>
      <hr></hr>

      <div className="grid grid-cols-3 gap-1 bg-white px-0">
        {form.img[0] ? (
          <div className="flex flex-col mb-4">
            <S3Image imgKey={item.img[0]} />
            <button
              onClick={onDeleteImg(0)}
              className="mt-3 w-20 inline-flex justify-center rounded-md border shadow-sm px-2 py-2 bg-red-400 text-base font-medium text-white hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm transition-all"
            >
              ลบ
            </button>
          </div>
        ) : (
          <ImageUploader
            withPreview={true}
            singleImage={true}
            withIcon={false}
            buttonText="Choose images"
            onChange={onDrop("picture")}
            imgExtension={[".jpg", ".gif", ".png", ".gif"]}
            maxFileSize={5242880}
          />
        )}
        {form.img[1] ? (
          <div className="flex flex-col mb-4">
            <S3Image imgKey={item.img[1]} />
            <button
              onClick={onDeleteImg(1)}
              className="mt-3 w-20 inline-flex justify-center rounded-md border shadow-sm px-2 py-2 bg-red-400 text-base font-medium text-white hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm transition-all"
            >
              ลบ
            </button>
          </div>
        ) : (
          <ImageUploader
            withPreview={true}
            singleImage={true}
            withIcon={false}
            buttonText="Choose images"
            onChange={onDrop("pictureSecond")}
            imgExtension={[".jpg", ".gif", ".png", ".gif"]}
            maxFileSize={5242880}
          />
        )}
        {form.img[2] ? (
          <div className="flex flex-col mb-4">
            <S3Image imgKey={item.img[2]} />
            <button
              onClick={onDeleteImg(2)}
              className="mt-3 w-20 inline-flex justify-center rounded-md border shadow-sm px-2 py-2 bg-red-400 text-base font-medium text-white hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm transition-all"
            >
              ลบ
            </button>
          </div>
        ) : (
          <ImageUploader
            singleImage={true}
            withPreview={true}
            withIcon={false}
            buttonText="Choose images"
            onChange={onDrop("pictureThird")}
            imgExtension={[".jpg", ".gif", ".png", ".gif"]}
            maxFileSize={5242880}
          />
        )}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Select
          value={form.category}
          onChange={onChangeSelect("category")}
          placeholder="หมวดหมู่"
          options={[
            { value: "สินค้า Platinum", label: "สินค้า Platinum" },
            { value: "สินค้า Gold", label: "สินค้า Gold" },
            { value: "สินค้า Premium", label: "สินค้า Premium" },
          ]}
        />

        <Select
          value={form.is_recommend}
          placeholder="เป็นสินค้า"
          options={[
            { value: true, label: "ยอดนิยม" },
            { value: false, label: "ทั่วไป" },
          ]}
          onChange={onChangeSelect("is_recommend")}
        />
        <input
          className="border border-gray-300 rounded p-2  focus:outline-none fo"
          placeholder="ชื่อสินค้า"
          value={form.name}
          name="name"
          onChange={onChangeTextField}
        />
        <input
          inputMode="decimal"
          className="border border-gray-300 rounded p-2  focus:outline-none"
          placeholder="ราคา"
          value={form.price}
          name="price"
          onChange={onChangeTextField}
        />
        <textarea
          inputMode="text"
          rows="4"
          className="border border-gray-300 rounded p-2  focus:outline-none "
          placeholder="คำอธิบาย"
          value={form.desc}
          name="desc"
          onChange={onChangeTextField}
        />
        <textarea
          inputMode="text"
          rows="4"
          className="border border-gray-300 rounded p-2 focus:outline-none"
          placeholder="เงื่อนไข"
          value={form.term}
          name="term"
          onChange={onChangeTextField}
        />
      </div>
    </div>
  );
}

export default GiftCreateUpdate;
/*
<div className="flex flex-row">
{modalItem.img.map((item, index) => {
    return <img src={item} className=" ml-1 w-60 h-auto"></img>
})}
</div>
<div className="flex flex-row">
<input type="file" className="my-4" name="myfile" />
<button className="w-32 my-3 text-white bg-green-500 rounded">อัพโหลด</button>

</div>

<div className="flex flex-col" >
<Select placeholder="หมวดหมู่" options={[{ value: 'แนะนำ', label: 'แนะนำ' },
{ value: 'สินค้าผู้ใหญ่ A', label: 'สินค้าผู้ใหญ่ A' },
{ value: 'สินค้าผู้ใหญ่ B', label: 'สินค้าผู้ใหญ่ B' },
{ value: 'สินค้าผู้ใหญ่ C', label: 'สินค้าผู้ใหญ่ C' },
{ value: 'สินค้าเด็ก A', label: 'สินค้าเด็ก A' },
{ value: 'สินค้าเด็ก B', label: 'สินค้าเด็ก B' },
{ value: 'สินค้าเด็ก C', label: 'สินค้าเด็ก C' }]} />
<div className="grid grid-cols-2 gap-4">
    <input className="border border-gray-300 rounded p-2 my-2" placeholder="ชื่อสินค้า" value={modalItem.name} />
    <input inputMode="decimal" className="border border-gray-300 rounded p-2 my-2" placeholder="ราคา" value={modalItem.price} />
</div>

<div className="grid grid-cols-2 gap-4">
    <textarea inputMode="text" rows="4" className="border border-gray-300 rounded p-2 my-2 mt-0" placeholder="คำอธิบาย" value={modalItem.price} />
    <textarea inputMode="text" rows="4" className="border border-gray-300 rounded p-2 my-2 mt-0" placeholder="เงื่อนไข" value={modalItem.price} />
</div>

<Switch checked={modalItem.is_recommend} label="เป็นสินค้าแนะนำ" onChange={(e) => {
    setModalItem({ ...modalItem, is_recommend: !modalItem.is_recommend })
}} />
</div>

</div>
<button className="bg-green-500 text-white p-2 w-full mt-8">เพิ่มสินค้า</button>
*/
